const states = {
  dashboard_details: {
    is_socket_connected: false,
    live_count: [],
    live_traffic_per_sec: [],
    live_traffic_per_min: [],
    dashboard_stats: [],
    selected_group: [], 
    stats_loading: false,
  },
}

export default states